import { NO_PATTERN_BUSINESS_LOGIC, createComponents, } from '@vfde-brix/ws10/core';
import { FULLWIDTH_NOTIFICATION_BASE_CLASSNAME } from './Constants';
import { createFullWidthNotification } from './FullWidthNotification';
createComponents(".".concat(FULLWIDTH_NOTIFICATION_BASE_CLASSNAME), createFullWidthNotification, NO_PATTERN_BUSINESS_LOGIC);
